// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Zsl9","type":"styles_type__3UFvx","choices":"styles_choices__2Ah7D"};